export const TimeDatePeriodOrLastDays = Object.freeze({
	LAST_30_DAYS: 'LAST_30_DAYS',
	MONTH: 'MONTH',
	YEAR: 'YEAR'
})
